import {
    InputBase,
    MenuItem,
    Select,
    ToggleButton,
    Tooltip,
} from '@mui/material';

import { fontList } from '../data';
import useMark from '../hooks/useMark';
import { ReactEditor, useSlate } from 'slate-react';
import { useTranslation } from 'react-i18next';

function SelectFont() {
    const { t } = useTranslation();
    const editor = useSlate();
    const { getMark, setMark, getFallbackValue } = useMark();

    const value =
        getMark('fontFamily') || getFallbackValue('font-family') || '';

    return (
        <Tooltip title={t('Font')}>
            <Select
                value={value}
                onChange={e => setMark('fontFamily', e.target.value)}
                input={<InputBase />}
                onClose={() => ReactEditor.focus(editor)}
                sx={{
                    width: 96,
                    // minWidth: 96,
                    // justifyContent: 'space-between',
                    height: 28,
                }}
                slots={{
                    root: ToggleButton,
                }}
                slotProps={{
                    root: {
                        value: false,
                    },
                }}
            >
                <MenuItem value="">
                    <em>{t('None')}</em>
                </MenuItem>
                {fontList.map(font => (
                    <MenuItem
                        key={font.value}
                        value={font.value}
                        sx={{ fontFamily: font.value }}
                    >
                        {font.label}
                    </MenuItem>
                ))}
            </Select>
        </Tooltip>
    );
}

export default SelectFont;
